module.exports = __webpack_public_path__ + "static/michael-sincere-fd7da0bbab3c47db1898c3162032946f.jpg";